export const theme = {
  wall: '#163057',
  path: '#ffff99',
  visited: '#99e6ff',
  darkVisited: '#1d70cf',
  border: '0.5px solid #2596be'
}